module.exports = __webpack_public_path__ + "static/media/Residential_31.384d4af1.jpg";